import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login.jsx';
import Admin from './pages/Admin.jsx';
import JoinForm from './pages/JoinForm.jsx';
import { isLoggedIn } from './auth.js';

function RequireAuth({ children }) {
  return isLoggedIn() ? children : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login"                 element={<Login />} />
      <Route path="/r/:token"              element={<JoinForm />} />
      <Route path="/r/:channel/:token"     element={<JoinForm />} />
      <Route path="/"                      element={<RequireAuth><Admin /></RequireAuth>} />
      <Route path="*"                      element={<Navigate to="/" replace />} />
    </Routes>
  );
}
